module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABOElEQVQ4T62TvUrEQBDH/wN+NQfZxkrETq8ysbC6wiAWvoEPIHiC9rbWlgo58UlsjIXWSSotLQS7bJSDA71jZJZE1j2TXOF2szPzm2+C87TWm8zcB7ADYK1UvwC4J6KBUiqzXagS4jie830/AnDoQm2ZmQdZlp2GYTiWfwMonWMAvSZnS/eQpmkoEAPQWt+0RXbBUo7necektfYBJHWR3z4I0eM8TnpfWO6waxZQURRR2bQphjhf3C1gvzvG3vpkSi9ZCOCJmTdcbZuzaSDRM+V5PiKiJRvwPgLObxdrI1e2zDxsBGyvTnCwZaZV94atJTRBTAmzNLEBcjXTGGUSZ7uff49RimvKoq74n0X6l1WuIEEQXNYtVZWJRE6S5Pcx2WnKahPRkZwzM6+UC/Mq58zM10qp1Lb/BqyNsJ0ux+p5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/fanhui.png
// module id = MHk5
// module chunks = 96